import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { KegtronService } from 'app/services/dal/kegtron.service';
import { OnTapBasicService } from 'app/services/dal/on-tap-basic.service';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as KegtronActions from './actions'
import { shouldLoadData, trackLoading } from '../effect-helpers';
import * as fromKegtron from './reducer';



@Injectable()
export class KegtronEffects {

  constructor(
    private actions$: Actions,
    private store: Store,
    private kegtronService: KegtronService) { }

  getKegs$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(KegtronActions.loadItems),
        shouldLoadData(
          this.store,
          'kegtron',
          (action) => action.barId,
          fromKegtron.selectAllItems
        ),
        switchMap((action) =>
          trackLoading(
            this.store,
            'kegtron',
            action.barId,
            this.kegtronService.getItems(action.barId).pipe(
              map(items => KegtronActions.loadItemsSuccess({ items: items })),
              catchError(error => of(KegtronActions.loadItemsFailure({ error })))
            )
          )
        )
      );
  });


}
